/** common */
export const DARK_TYPE = 'c203638321902372'
export const SHOW_SETTINGS_DRAWER = 'c745239362614191'
/** slider bar */
export const SIDEBAR_COLOR = 'c877341516661131'
export const SIDEBAR_THEME = 'c021052098400325'
export const SIDENAV_TYPE = 'c021052098400326'
export const SIDEBAR_TEXT_COLOR = 'c877341516661132'
export const SIDEBAR_SELECTED_TEXT_COLOR = 'c877341516661133'
export const SIDEBAR_COLOR_MODEL = 'c027017650640464'
export const SIDEBAR_THEME_MODEL = 'c858131126884552'
/** nav */
export const NAVBAR_FIXED = 'c259008291194160'
export const NAVBAR_DARK_MODEL = 'c020517268490514'
export const NAVBAR_FIXED_MODEL = 'c002083395742376'
/** user */
export const USER = 'c505861817790729'
export const TOKEN = 'c627103308664297'
export const SETTING_BREAKCRUMB = 'c342838893859366'
export const USER_RANK = 'c557188281418070'
export const USER_LOGINED = 'c322794676352486'
export const COOKIE15 = 'c066664099563472'
/** Redis */
export const MENU_HEADER_TOP1_COOKIE = '8119801281209372730'
export const COMPANY_DETAIL_COOKIE = '8119803581209372729'